import React from 'react';
import { useDelete } from '../graphql/hooks';
import Loading from '../teal-react/components/molecules/Loading';
import SimpleTable from '../teal-react/components/organisms/SimpleTable';
import Utils from '../teal-react/utils';
import { Alert, IconButton } from '@mui/material';
import { DeleteOutline, EditOutlined } from '@mui/icons-material';
import SimpleDeleteConfirm from '../teal-react/components/organisms/SimpleDeleteConfirm';
import SimpleModal from '../teal-react/components/organisms/SimpleModal';
import FormulaMaterialForm from './FormulaMaterialForm';
import { useMaterialsEditor } from '../graphql/queries';
// import { Api, Utils } from '@jesseteal/teal-react'

interface MaterialsEditorProps {
  id: number;
}
const MaterialsEditor = ({ id }: MaterialsEditorProps) => {
  const [deleteId, setDeleteId] = React.useState(0);
  const [selected, setSelected] = React.useState<any>();
  const deleteMat = useDelete('formula_material', 'formula_material');
  const { data } = useMaterialsEditor(id);
  if (!data) {
    return <Loading />;
  }
  return (
    <>
      <SimpleTable
        noCard
        data={data.materials}
        actionsLeft={[
          {
            label: 'Add Material',
            onClick: () => {
              setSelected({
                formula_id: id,
                ordinal: data.materials.length + 1,
              });
            },
          },
        ]}
        summaryRow={[
          {
            colSpan: 4,
            cell: () => null,
          },
          {
            colSpan: 2,
            bold: false,
            cell: (rows: any[]) => {
              const total: Number = rows.reduce((a, i) => {
                return a + i.weight_percentage;
              }, 0);
              const rounded_total = +total.toFixed(3);
              if (rounded_total !== 100 && rounded_total !== 0) {
                return (
                  <Alert severity="warning" color="warning">
                    {rounded_total < 100
                      ? `Weight % Missing ${(100 - rounded_total).toFixed(3)}%`
                      : `Weight % off by ${(rounded_total - 100).toFixed(3)}%`}
                  </Alert>
                );
              }
              return null;
            },
            align: 'right',
          },
        ]}
        columns={[
          {
            header: 'Material',
            cell: (r: any) => r.material.name,
          },

          {
            header: 'Amount',
            cell: (r: any) => `${r.amount || ''} ${r.unit?.name || ''}`,
            align: 'right',
          },
          {
            header: 'Price',
            cell: (r: any) => Utils.formatMoney(r.material.price),
          },
          {
            header: 'Density',
            cell: (r: any) => Utils.formatNumber(r.material.density, 4),
          },
          {
            header: 'Weight %',
            cell: (r: any) => `${r.weight_percentage}%`,
            align: 'right',
          },
          { header: 'Remark' },
          {
            header: '',
            sort: false,
            cell: (r: any) => (
              <span>
                <IconButton onClick={() => setSelected(r)}>
                  <EditOutlined color="primary" />
                </IconButton>
                <IconButton
                  onClick={() => {
                    setDeleteId(r.id);
                  }}
                >
                  <DeleteOutline color="error" />
                </IconButton>
              </span>
            ),
          },
        ]}
      />
      {deleteId ? (
        <SimpleDeleteConfirm
          onCancel={() => setDeleteId(0)}
          onDelete={() => {
            deleteMat({ id: deleteId });
            setDeleteId(0);
          }}
        />
      ) : null}
      {selected ? (
        <SimpleModal open={true} size="md">
          <FormulaMaterialForm
            model={selected}
            onClose={() => setSelected(null)}
          />
        </SimpleModal>
      ) : null}
    </>
  );
};

export default MaterialsEditor;
